<template>
  <span class="desensitize">
    <span>{{ showClearText ? textCleared : text }}</span>
    <span v-if="clearText" :loading="loading" @click.stop="changeMode">
      <span
        :class="{
          eyefill: showClearText,
          eyeclose: !showClearText,
          eyeicon: true,
        }"
      ></span>
    </span>
  </span>
</template>
<script>
export default {
  name: "Desensitize",
  components: {},
  mixins: [],
  props: {
    queryKey: {
      type: [String, Number],
      default: "",
    },
    clearText: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: "",
    },
    userType: {
      type: Number,
      default: 1, // 1查订单详情 2查客户详情，3查线索详情 4查客流统计详情 5查盲订订单详情 6查小订订单详情
    },
  },
  data() {
    return {
      dealer: this.$common.getLoginInfo().profile,
      showClearText: false,
      loading: false,
      textCleared: "",
    };
  },
  methods: {
    changeMode() {
      if (this.showClearText) {
        this.showClearText = false;
      } else {
        this.loading = true;
        if(this.userType === 1) {
          this.$httpAuth
            .post("/v2/appCustomerService/orderDetail", {
              orderId: this.queryKey,
              dealerId: this.dealer.dealerId,
            })
            .then((res) => {
                const { customerPhone = '' } = res?.data?.order;
                this.textCleared = customerPhone;
                this.showClearText = true;
              }).finally(() => {
                this.loading = false;
              });
        } else if(this.userType === 2) {  
          this.$httpAuth
            .post("/v2/appCustomerService/get", {
              customerId: this.queryKey,
              dealerId: this.dealer.dealerId,
            })
            .then((res) => {
                const { mobile = '' } = res?.data?.customer;
                this.textCleared = mobile;
                this.showClearText = true;
              }).finally(() => {
                this.loading = false;
              });
        } else if(this.userType === 3) { 
          this.$httpAuth
            .post("/v2/appClueService/detail", {
              clueId: this.queryKey,
              dealerId: this.dealer.dealerId,
            })
            .then((res) => {
                const { phone = '' } = res?.data?.data;
                this.textCleared = phone;
                this.showClearText = true;
              }).finally(() => {
                this.loading = false;
              });
        } else if(this.userType === 4) { 
          this.$httpAuth
            .post("/v2/appCustomerFlowService/flowDetail", {
              flowId: this.queryKey,
              dealerId: this.dealer.dealerId,
            })
            .then((res) => {
                const { mobile = '' } = res?.data?.data;
                this.textCleared = mobile;
                this.showClearText = true;
              }).finally(() => {
                this.loading = false;
              });
        } else if(this.userType === 5) { 
          this.$httpAuth
            .post("/v2/appCustomerService/blindOrderDetail", {
              blindOrderId: this.queryKey,
              dealerId: this.dealer.dealerId,
            })
            .then((res) => {
                const { customerPhone = '' } = res?.data?.blindOrder;
                this.textCleared = customerPhone;
                this.showClearText = true;
              }).finally(() => {
                this.loading = false;
              });
        } else if(this.userType === 6) { 
          this.$httpAuth
            .post("/v2/appCustomerService/preOrderDetail", {
              preOrderId: this.queryKey,
              dealerId: this.dealer.dealerId,
            })
            .then((res) => {
                const { customerPhone = '' } = res?.data?.preOrder;
                this.textCleared = customerPhone;
                this.showClearText = true;
              }).finally(() => {
                this.loading = false;
              });
        }
      }
    },
  },
};
</script>
<style scoped>
.desensitize {
}
.eyefill {
  background-image: url("../../assets/svg/eye-fill.svg");
}
.eyeclose {
  background-image: url("../../assets/svg/eye-close-fill.svg");
}
.eyeicon {
  display: inline-block;
  vertical-align: middle;
  margin-left: 5px;
  padding: 2px;
  width: 16px;
  height: 16px;
  background-size: contain;
  background-repeat: no-repeat;
  cursor: pointer;
}
</style>
